import { render, staticRenderFns } from "./CoffeeStore.vue?vue&type=template&id=0f125995&"
import script from "./CoffeeStore.vue?vue&type=script&lang=js&"
export * from "./CoffeeStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports